import { render } from "./StartJob.vue?vue&type=template&id=288cedea"
import script from "./StartJob.vue?vue&type=script&lang=ts"
export * from "./StartJob.vue?vue&type=script&lang=ts"

import "./StartJob.vue?vue&type=style&index=0&id=288cedea&lang=scss"
script.render = render

export default script